<app-social [inline]="true" [gtm]="'login_socialConnect_'" mode="login"></app-social>

<form class="kz-loginV2-form" [formGroup]="loginForm" (ngSubmit)="save()" novalidate appGtmTrack="login_form" trackChildren="false">
    <div *ngIf="bannedAction" class="kz-field-full">
        <p class="kz-info" i18n="@@auth.login.bannedActionMsg">You must be logged in to complete this action</p>
    </div>

    <kz-field class="kz-field-full" absErrorMsg="true" [hasError]="isFieldInvalid('emailOrPhone')">
        <label kzLabel for="kz-textbox-email-2" i18n="@@auth.login.email">Pseudo or email</label>
        <input kzTextBox id="kz-textbox-email-2" type="text" placeholder="Enter your pseudo or email" i18n-placeholder="@@auth.login.email.placeholder" (blur)="checkValue()" formControlName="emailOrPhone"/>
        <p kzError *ngIf="isFieldInvalid('emailOrPhone')"><span i18n="@@auth.errors.required">Required</span></p>
    </kz-field>
    <kz-tooltip *ngIf="emailStarred" class="kz-tooltip--email" tooltipContext="dark" tooltipArrowPosition="top-left">
        <ng-container i18n="@@auth.login.email.check">Please enter the email address of your account kozikaza : {{ emailStarred }}</ng-container>
    </kz-tooltip>

    <kz-field class="kz-field-full" absErrorMsg="true" [hasError]="isFieldInvalid('password')">
        <label kzLabel for="kz-textbox-password-2" i18n="@@auth.login.password">Password</label>
        <input kzTextBox id="kz-textbox-password-2" [type]="(showPassword) ? 'text' : 'password'" placeholder="Password" i18n-placeholder="@@auth.login.password.placeholder" formControlName="password"/>
        <span class="kz-field-suffix" (click)="showPassword= !showPassword"><kz-icons name="discover"></kz-icons></span>
        <p kzError *ngIf="isFieldInvalid('password')"><span i18n="@@auth.errors.required">Required</span></p>
    </kz-field>

    <div *ngIf="wrongLogin" class="kz-field-full">
        <p kzError><span i18n="@@auth.login.errorMsg">Your email or password is incorrect.</span></p>
    </div>

    <div class="kz-field-full">
        <p><a class="kz-forgot-password" [routerLink]="['', {outlets: {auth: ['authentification', 'forgot-password'], modal: null}}]"  appGtmTrack="forgotPassword" data-cy="reset" i18n="@@auth.forgotPassword">Forgot password ?</a></p>
    </div>
</form>
